import Login from "features/login/containers/Login";
import React from "react";

const LoginComponent = () => {
  return <Login />;
};

export default LoginComponent;
